<template>
  <el-card
    class="account-remittance-not-account business-handling my-card"
    :body-style="cardBody"
  >
    <el-page-header>
      <template slot="content"
        ><span style="font-size:14px">{{
          $t("partnerTransfers")
        }}</span></template
      >
    </el-page-header>
    <div class="form-container">
      <el-divider content-position="left">
        <el-form
          inline
          ref="queryForm"
          :model="queryForm"
          :rules="rules"
          style="height:45px;overflow:hidden;"
        >
          <el-form-item
            :label="$t('accountInfo')"
            prop="param"
            style="margin-bottom:0"
          >
            <el-input
              size="mini"
              v-model="queryForm.param"
              :placeholder="$t('inputPhoneOrAccount')"
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom:0">
            <el-button
              size="mini"
              type="primary"
              @click="onQuery('queryForm')"
              >{{ $t("queryAccountInfo") }}</el-button
            >
          </el-form-item>
        </el-form>
      </el-divider>
      <!-- 存款信息 -->
      <el-form
        v-if="remitterInfo"
        ref="addForm"
        :model="addForm"
        :rules="rules"
        label-position="top"
      >
        <el-input
          type="hidden"
          size="medium"
          v-model="remitterInfo.businessCode"
          disabled
        ></el-input>
        <el-row :gutter="20">
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('firstName')">
              <el-input
                size="medium"
                v-model="remitterInfo.firstName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('lastName')">
              <el-input
                size="medium"
                v-model="remitterInfo.lastName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('phone')">
              <el-input
                size="medium"
                v-model="remitterInfo.phone"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('idNumber')">
              <el-input
                size="medium"
                v-model="remitterInfo.idCard"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('accountAmount')">
              <el-input
                size="medium"
                v-model="remitterInfo.accountAmount"
                disabled
              >
                <template slot="prepend"
                  ><i
                    class="iconfont iconruishifalang"
                    style="font-size:14px"
                  ></i>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('account')">
              <el-input
                size="medium"
                v-model="remitterInfo.cardNo"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">{{ $t("partnerInfo") }}</el-divider>
        <el-row :gutter="20">
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('bankName')" prop="bankId">
              <el-select
                size="medium"
                v-model="addForm.bankId"
                filterable
                :placeholder="$t('selectBank')"
                style="width:100%;"
              >
                <el-option
                  v-for="item in bankList"
                  :key="item.id"
                  :label="item.bankName"
                  :value="item.id"
                  v-show="item.status === 0"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('applyCode')" prop="transferCode">
              <el-input size="medium" v-model="addForm.transferCode"></el-input>
            </el-form-item>
          </el-col>

          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item
              :label="$t('transferDatePartner')"
              prop="transferDate"
            >
              <el-date-picker
                v-model="addForm.transferDate"
                type="datetime"
                :time-arrow-control="true"
                :format="'yyyy-MM-dd HH:mm:ss'"
                :placeholder="$t('selectDateAndTime')"
                style="width:100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('amountTransfer')" prop="amount">
              <el-input type="number" size="medium" v-model="addForm.amount">
                <template slot="prepend"
                  ><i
                    class="iconfont iconruishifalang"
                    style="font-size:14px"
                  ></i>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bottom-button" v-if="remitterInfo">
      <el-button
        size="medium"
        :loading="isLoading"
        type="primary"
        @click="onSubmit('addForm')"
        >{{ $t("submit") }}</el-button
      >
    </div>
  </el-card>
</template>

<script>
import customer from "@/api/customer";
//import transactionInfo from "@/api/transactionInfo";
import bank from "@/api/bank";
import manba from "@/assets/uilt/manbaDate";

//
export default {
  components: {},
  data() {
    return {
      isLoading: false,

      /**查询存款人信息 */
      queryForm: {},
      /**存款人信息 */
      remitterInfo: null,
      /**存款信息 */
      addForm: {},
    };
  },
  computed: {
    cascader() {
      return this.$store.state.format.cascader;
    },
    cardBody() {
      return this.$store.state.style.cardBody;
    },
    countryTree() {
      return this.$store.state.globalParameter.countryTree;
    },
    rules() {
      return {
        bankId: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        transferCode: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        transferDate: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  watch: {},
  methods: {
    onQuery(refName) {
      let _this = this;
      this.$refs[refName].validate((valid) => {
        if (valid) {
          let p = {};
          if (_this[refName].param.length === 15)
            p.cardNo = _this[refName].param;
          else p.phone = _this[refName].param;

          customer.getPartnerByAccountOrPhone({
            param: p,
            success: (res) => {
              if (res.code != 200) {
                _this.$message.warning(_this.$t(res.msg));
                return;
              }
              _this.remitterInfo = {
                businessCode: _this.$route.params.code,
                firstName: res.data.name,
                lastName: res.data.surname,
                phone: res.data.phoneNo,
                idCard: res.data.idCard,
                accountAmount: res.data.accountAmount,
                cardNo: res.data.cardNo,
                cardId: res.data.cardId,
              };
            },
          });
        } else return false;
      });
    },
    getBankList() {
      let _this = this;
      bank.getAllBank({
        success: (res) => {
          if (res.code != 200) return;
          _this.bankList = res.data;
        },
      });
    },

    onSubmit(refName) {
      let _this = this;
      _this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        _this.isLoading = true;

        let p = Object.assign(_this[refName], {
          phone: _this.remitterInfo.phone,
        });
        _this[refName].transferDate = manba(_this[refName].transferDate).format(
          "ymdhms",
        );
        bank.partnerDeposit({
          param: p,
          success: (res) => {
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));

              _this.remitterInfo = {
                businessCode: "",
                firstName: "",
                lastName: "",
                phone: "",
                idCard: "",
                accountAmount: "",
                cardNo: "",
                cardId: "",
              };
              _this.addForm = {
                transferCode: "",
                transferDate: "",
                amount: "",
                phone: "",
              };
              _this.queryForm = {
                param: "",
              };
              _this.getBankList();
            } else {
              _this.$message.warning(_this.$t(res.msg));
            }
            _this.isLoading = false;
          },
        });
      });
    },
  },
  mounted() {
    this.getBankList();
  },
};
</script>

<style lang="less" scoped>
.account-remittance-not-account.business-handling {
  height: 100%;
  width: 100%;
  .el-card__body {
    position: relative;
    .form-container {
      position: absolute;
      top: 60px;
      bottom: 80px;
      left: 20px;
      right: 0;
      padding-right: 20px;
      overflow: auto;
    }
  }
  .el-form {
    height: auto;
  }
}
</style>
